import React__default from 'react';
import PropTypes from 'prop-types';

var propTypes = {
  /** Main content area, typically product details or additional links */
  children: PropTypes.node.isRequired,
  /** Optional header content, such as product codes or meta info */
  header: PropTypes.node,
  /** Product image element (e.g., `<ProductImage />` or a button-wrapped image) */
  productImage: PropTypes.node.isRequired,
  /** Product name element (e.g., `<ProductName />` with a heading) */
  productName: PropTypes.element.isRequired,
  /** Product price element (e.g., `<ProductPrice />`), supports discount and original prices */
  productPrice: PropTypes.node,
  /** Optional badge element (e.g., `<Badge />`) to display at the top of the card */
  badge: PropTypes.element,
  /** Optional close/remove button (e.g., `<IconButton />`) for dismissing or removing product */
  closeButton: PropTypes.element,
  /** Optional footer content, such as actions or additional info */
  footer: PropTypes.node,
  /** Visual style of the card */
  variant: PropTypes.oneOf(['bordered', 'boxed'])
};
function ProductCard(_ref) {
  var badge = _ref.badge,
    children = _ref.children,
    closeButton = _ref.closeButton,
    footer = _ref.footer,
    header = _ref.header,
    productImage = _ref.productImage,
    productName = _ref.productName,
    productPrice = _ref.productPrice,
    variant = _ref.variant;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "productcard",
    "data-testid": "productcard",
    "data-badge": !!badge,
    "data-footer": !!footer,
    "data-variant": variant
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "productcard-badge"
  }, badge), /*#__PURE__*/React__default.createElement("span", null), /*#__PURE__*/React__default.createElement("span", null), /*#__PURE__*/React__default.createElement("span", {
    className: "productcard-Image"
  }, productImage), /*#__PURE__*/React__default.createElement("div", {
    className: "productcard-content",
    "data-testid": "productcard-content"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "productcard-header",
    "data-testid": "productcard-header"
  }, header, closeButton && /*#__PURE__*/React__default.createElement("div", {
    className: "close",
    "data-testid": "close-button"
  }, closeButton), productName), /*#__PURE__*/React__default.createElement("div", {
    className: "productcard-description",
    "data-testid": "productcard-description"
  }, children), /*#__PURE__*/React__default.createElement("span", {
    className: "productcard-price",
    "data-testid": "productcard-price"
  }, productPrice)), footer ? /*#__PURE__*/React__default.createElement("div", {
    className: "productcard-footer",
    "data-testid": "productfooter"
  }, footer) : null);
}
ProductCard.propTypes = propTypes;

export { ProductCard as default };
//# sourceMappingURL=ProductCard.js.map
